export enum AirdropFilterEnum {
  UPCOMING = "UPCOMING",
  AVAILABLE = "LIVE",
  ENDED = "END",
  JOINED = "JOINED",
}

export enum ProjectEnum {
  LIVE = "live",
  UPCOMING = "upcoming",
  ENDED = "ended",
}

export enum AirdropNFTEnum {
  Claimable = "CLAIMABLE",
  Eligible = "ELIGIBLE",
  All = "ALL",
}

export enum NFTMintedState {
  MINTED = "minted",
  CLAIMABLE = "claimable",
  NOT_wHITELIST = "notWhitelist",
}
